export default __webpack_public_path__ + "static/media/operator-losses.f78dda88.svg";